import AuthTimeoutHandler from "../components/AuthTimeoutHandler";
import FocusOutlineHandler from "../components/FocusOutlineHandler";
import { FocusOutlineStyle, ApplicationGlobalStyle } from "./commonStyles";
import GlobalErrorHandler from "../components/GlobalErrorHandler";
import GlobalStyle from "@storeblocks/global-styles";
import React from "react";
import { Provider as ReduxProvider } from "react-redux";
import RootRouter from "../router";
import { TranslationProvider } from "@storebrand-digital/fms-translations-react";
import en from "../fms-fallbacks/fallback-en.json";
import no from "../fms-fallbacks/fallback-no.json";
import packageJson from "../../package.json";
import store from "../store";
import { ApplicationWrapper } from "./ApplicationWrapper";

const App: React.FC = () => {
  return (
    <ReduxProvider store={store}>
      <AuthTimeoutHandler />
      <FocusOutlineStyle />
      <FocusOutlineHandler />
      <GlobalStyle />
      <ApplicationGlobalStyle />
      <GlobalErrorHandler />
      <TranslationProvider
        document="edh2CustomerWeb"
        clientId={packageJson.name || "edh2-customer-web"}
        fallback={{ no, en }}
      >
        <ApplicationWrapper>
          <RootRouter />
        </ApplicationWrapper>
      </TranslationProvider>
    </ReduxProvider>
  );
};

export default App;
